/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VendorTicketDto } from '../../models/vendor-ticket-dto';

export interface VendorTicketControllerFindById$Params {
  id: string;
}

export function vendorTicketControllerFindById(http: HttpClient, rootUrl: string, params: VendorTicketControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorTicketDto>> {
  const rb = new RequestBuilder(rootUrl, vendorTicketControllerFindById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VendorTicketDto>;
    })
  );
}

vendorTicketControllerFindById.PATH = '/api/vendor-ticket/{id}';
